document.addEventListener("alpine:init", () => {
    Alpine.data("gridFilter", () => ({
        currentFilters: {},
        dropdownOpen: null,
        showResetBtn: false,
        searchTerm: "",
        filterPrefix: {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            search: "",
        },
        openDropdowns: {},
        targetGridId: null,
        init() {
            this.currentFilters = this.getCurrentFilters();
            this.targetGridId = this.$el.dataset.gridFilter;
        
            if (this.currentFilters["filter-search"]) {
              this.searchTerm = this.currentFilters["filter-search"];
            }
        
            if (Object.keys(this.currentFilters).length) {
              this.showResetBtn = true;
            }

            this.$watch("searchTerm", (value) => {
              this.currentFilters["filter-search"] = value;
        
              if (!value) {
                delete this.currentFilters["filter-search"];
              }
        
              window.dispatchEvent(new CustomEvent("pegasusgridfiltertoggle", { detail: {
                currentFilters: this.currentFilters,
                targetGridId: this.targetGridId
                }
              }));
        
              this.showResetBtn = Object.keys(this.currentFilters).length > 0;
            });
        },        
        selectFilter(term, filterName, type = "taxonomy") {
            this.toggleFilters(term, filterName, type);
            this.$dispatch("pegasusgridfiltertoggle", {
                currentFilters: this.currentFilters,
                targetGridId: this.targetGridId
            });
            this.showResetBtn = true;
            this.dropdownOpen = null;
        },
        selectSingleTaxFilter(term, filterName, type = "taxonomy") {
            Object.keys(this.currentFilters).forEach((key) => {
              if (key.startsWith(this.filterPrefix.taxonomy)) {
                delete this.currentFilters[key];
              }
            });
      
            const filter = this.getPrefixedFilter(filterName, type);
            this.currentFilters[filter] = term;
      
            this.$dispatch("pegasusgridfiltertoggle", {
              currentFilters: this.currentFilters,
              targetGridId: this.targetGridId
            });
      
            this.showResetBtn = true;
            this.dropdownOpen = null;
        },
        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);
            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;
                return;
            }
            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    this.currentFilters[filter] = this.removeFilter(filter, term);
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                this.currentFilters[filter] = term;
            }
        },
        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");
            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }
            return filterValueArray.toString();
        },
        clearFilters() {
            this.currentFilters = {};
            this.searchTerm = "";
            
            // Use pegasus.ajaxContent to handle the AJAX request
            const currentUrl = pegasus.getURL();
            const data = {
                action: 'pegasus_grid_filter',
                filters: JSON.stringify({}),
                nonce: pegasus.nonce
            };
            
            pegasus.ajaxContent(currentUrl, ['[data-pegasus-filterable="' + this.targetGridId + '"]'], data, () => {
                this.$dispatch("pegasusgridfiltertoggle", { 
                    currentFilters: {},
                    targetGridId: this.targetGridId
                });
                this.showResetBtn = false;
                
                // Update URL without page reload
                const url = new URL(window.location.href);
                url.search = '';
                window.history.pushState({}, '', url);
            });
        },
        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
        getCurrentFilters() {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            let currentFilters = {};
            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }
            return currentFilters;
        },
        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            if (typeof this.currentFilters[filterName] !== "undefined") {
                return this.currentFilters[filterName].includes(term);
            }
            return false;
        },
    }));
});
